import {
  CardHeader,
  Card,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Table,
} from 'reactstrap'
import { useSelector } from 'react-redux'

import Loader from 'views/pages/Loader'
import './style.css'
import { useRewards } from '../../Admin/useRewards'
import Select from 'views/pages/Select'
import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import defaultAvatar from '../../../../../assets/img/brand/img_avatar.png'
import defaultRewardImage from './kiwi_default_badge.png'
import { setRewards } from 'store/Dashboard/actions'
import { useDispatch } from 'react-redux'

const Rewards = () => {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}
  const dispatch = useDispatch()

  const [typeChanged, setTypeChanged] = useState(false)

  // Fetching rewards
  const { fetchRewards } = useRewards()

  const {
    rewardsData: {
      roleArray,
      loading,
      storesWithRewards,
      selectedRewardRole,
      userRewards,
      usersLoading,
      rewardsType,
    },
  } = useSelector((state) => state.dashboard)

  const changeRewardsType = () => {
    setTypeChanged(true)
    if (rewardsType === 'users') {
      dispatch(setRewards({ rewardsType: 'location' }))
    } else {
      dispatch(setRewards({ rewardsType: 'users' }))
    }
  }

  useEffect(() => {
    if (!typeChanged) return
    fetchRewards()
  }, [rewardsType, typeChanged])

  return (
    <Card
      // style={{ height: '420px' }}
      className='h-100 card-margin'
    >
      <CardHeader>
        <div
          className='d-flex justify-content-between'
          style={{ minHeight: '32px' }}
        >
          <span className='h3 mb-0'>Rewards</span>

          {rewardsType === 'location' && (
            <div className='text-right'>
              <small className='mr-1'>Filter by job role</small>
              <UncontrolledDropdown>
                <DropdownToggle
                  color=''
                  className='btn-icon-only border-light bg-gray-200'
                  size='sm'
                  data-boundary='viewport'
                >
                  <i className='fas fa-ellipsis-v text-light' />
                </DropdownToggle>

                <DropdownMenu
                  className='dropdown-menu-arrow overflow-auto'
                  right
                >
                  <DropdownItem onClick={() => fetchRewards()} className='py-2'>
                    All
                  </DropdownItem>

                  {roleArray.length > 0 ? (
                    roleArray.map((role, index) => (
                      <DropdownItem
                        key={index}
                        className='py-2'
                        onClick={() => fetchRewards(role)}
                      >
                        {role}
                      </DropdownItem>
                    ))
                  ) : (
                    <DropdownItem>No roles available</DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )}
        </div>
        <div className='d-flex'>
          <div className='mr-3'>
            <input
              type='radio'
              checked={rewardsType === 'users'}
              onChange={changeRewardsType}
              className='my-2'
              value={'usersRewards'}
              id={'usersRewards'}
            />
            <label className='m-2' htmlFor={'usersRewards'}>
              Users
            </label>
          </div>
          <div className=''>
            <input
              type='radio'
              checked={rewardsType === 'location'}
              onChange={changeRewardsType}
              className='my-2'
              value={'locationRewards'}
              id={'locationRewards'}
            />
            <label className='m-2' htmlFor={'locationRewards'}>
              Location
            </label>
          </div>
        </div>
      </CardHeader>

      <div className='table-responsive h-100 scrollbar'>
        <Table className='table-flush '>
          {rewardsType === 'users' ? (
            <thead className='thead-light'>
              <tr>
                <th className='pb-3 text-center'>Rank</th>
                <th className='pb-3 text-center'>Profile</th>
                <th className='pb-3 text-center'>Name</th>
                <th className='pb-3 text-center'>Points</th>
              </tr>
            </thead>
          ) : (
            <thead className='thead-light'>
              <tr>
                <th className='pb-3 text-center'>
                  {language.settings
                    ? language.settings.assign_to_location
                    : null}
                </th>
                <th className='pb-3 text-center'>
                  {language.general ? language.general.rewards : null}
                </th>
                <th className='pb-3 text-center'>
                  {language.courses ? language.courses.points : null}
                </th>
                <th className='pb-3 text-center'>
                  {language.settings ? language.settings.roles : null}
                </th>
              </tr>
            </thead>
          )}

          <tbody style={{ overflowX: 'auto' }}>
            {(usersLoading && rewardsType === 'users') ||
            (loading && rewardsType === 'location') ? (
              <tr>
                <td className='text-center' colSpan={4}>
                  <Loader />
                </td>
              </tr>
            ) : rewardsType === 'users' &&
              userRewards &&
              userRewards.length > 0 ? (
              userRewards.map((user, index) => (
                <tr key={index}>
                  <td className='text-center'>#{index + 1}</td>
                  <td className='text-center'>
                    <img
                      alt='test'
                      className='leaderboard-avatar'
                      src={
                        user.avatar
                          ? JSON.parse(user.avatar).url
                          : defaultAvatar
                      }
                    />
                  </td>
                  <td className='text-center'>
                    <div className='user-info'>
                      {user.first_name} {user.last_name}
                      {user.rewards.length > 0 &&
                        user.rewards
                          .slice(0, 3)
                          .map((reward) => (
                            <img
                              title={reward.name}
                              alt={reward.name}
                              className='user-reward'
                              key={reward.id}
                              src={
                                reward.image ? reward.image : defaultRewardImage
                              }
                            />
                          ))}
                      {user.rewards.length > 3 && (
                        <span
                          title={`and ${
                            user.rewards.length - 3
                          } other rewards!`}
                          className='user-reward-dots'
                        >
                          &middot; &middot; &middot;
                        </span>
                      )}
                    </div>
                  </td>
                  <td className='text-center'>{user.rewards_points}</td>
                </tr>
              ))
            ) : storesWithRewards.length > 0 ? (
              storesWithRewards.map((store, index) => (
                <tr key={index}>
                  <td className='text-center'>
                    <h5 className=' mb-0'>{store.store_name}</h5>
                  </td>
                  <td className='text-center'>
                    <i
                      className='fas fa-award pr-2 text-info'
                      style={{ fontSize: '19px' }}
                    />
                    <span>{store.rewards}</span>
                  </td>
                  <td className='pb-0 text-center'>
                    <p>{store.points}</p>
                  </td>
                  <td className='text-center'>
                    <p className=' mb-0'>{selectedRewardRole}</p>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className='text-center' colSpan={4}>
                  No rewards found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </Card>
  )
}

export default Rewards
